export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img 
          src="https://readdy.ai/api/search-image?query=Modern%20abstract%20digital%20technology%20background%20with%20flowing%20geometric%20shapes%2C%20neural%20network%20patterns%2C%20and%20gradient%20mesh%20in%20deep%20navy%20blue%2C%20electric%20cyan%2C%20and%20purple%20colors%2C%20minimalist%20futuristic%20design%20with%20soft%20lighting%2C%20clean%20professional%20aesthetic%20perfect%20for%20tech%20company%20hero%20section%2C%20ultra%20high%20quality%208k&width=1920&height=1080&seq=hero-bg-001&orientation=landscape"
          alt="Digital Technology Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 via-slate-900/85 to-blue-900/80"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6 lg:space-y-8">
            <div className="space-y-4 lg:space-y-6">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold text-white leading-tight">
                Professional
                <br />
                <span className="bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
                  Website Design
                </span>
                <br />
                For Your Business
              </h1>
              <p className="text-base sm:text-lg lg:text-xl text-cyan-100 leading-relaxed max-w-xl mx-auto lg:mx-0">
                Custom website design solutions tailored for small and medium businesses. Affordable, modern, and results-driven websites that help you grow online
              </p>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <button 
                onClick={scrollToContact}
                className="px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-cyan-500 to-blue-600 text-white text-sm sm:text-base font-semibold rounded-full hover:shadow-lg hover:shadow-cyan-500/50 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Get Your Website
              </button>
              <button 
                onClick={scrollToContact}
                className="px-6 sm:px-8 py-3 sm:py-4 border-2 border-white text-white text-sm sm:text-base font-semibold rounded-full hover:bg-white hover:text-slate-900 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Free Consultation
              </button>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-3 sm:gap-6 pt-6 lg:pt-8">
              <div className="bg-white/10 backdrop-blur-md rounded-xl sm:rounded-2xl p-3 sm:p-4 border border-white/20">
                <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-white">50+</div>
                <div className="text-xs sm:text-sm text-cyan-200">SMB Websites</div>
              </div>
              <div className="bg-white/10 backdrop-blur-md rounded-xl sm:rounded-2xl p-3 sm:p-4 border border-white/20">
                <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-white">5 Days</div>
                <div className="text-xs sm:text-sm text-cyan-200">Avg Launch</div>
              </div>
              <div className="bg-white/10 backdrop-blur-md rounded-xl sm:rounded-2xl p-3 sm:p-4 border border-white/20">
                <div className="text-xl sm:text-2xl lg:text-3xl font-bold text-white">100%</div>
                <div className="text-xs sm:text-sm text-cyan-200">Mobile Ready</div>
              </div>
            </div>
          </div>

          {/* Right Visual */}
          <div className="hidden lg:block relative">
            <div className="relative w-full h-[500px]">
              {/* Floating Elements */}
              <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-cyan-400/30 to-blue-600/30 rounded-3xl backdrop-blur-xl border border-white/20 transform rotate-12 animate-float"></div>
              <div className="absolute bottom-0 left-0 w-56 h-56 bg-gradient-to-br from-purple-400/30 to-pink-600/30 rounded-3xl backdrop-blur-xl border border-white/20 transform -rotate-12 animate-float-delayed"></div>
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-72 h-72 bg-gradient-to-br from-blue-500/20 to-cyan-500/20 rounded-full backdrop-blur-xl border border-white/20"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-white/50 rounded-full"></div>
        </div>
      </div>
    </section>
  );
}